module.exports = __webpack_public_path__ + "img/dp-dy-sy9.0.94de45eb.png";